/// <reference types="vite/client" />

// 게임 서버 주소 자동 판별.
// - 개발: vite dev 서버(3000)에서 서빙되므로 게임 서버는 별도 포트 → ws://localhost:2567
// - 프로덕션: 서버가 클라이언트 정적 파일을 직접 서빙(단일 오리진)하므로
//   현재 접속 주소를 그대로 쓴다 (https 접속이면 wss, 리버스 프록시 뒤에서도 동작).
const { protocol, host } = window.location;

export const SERVER_URL: string = import.meta.env.DEV
  ? "ws://localhost:2567"
  : `${protocol === "https:" ? "wss" : "ws"}://${host}`;

export const API_URL: string = SERVER_URL.replace(/^ws/, "http");

// 게임 중 API 요청 공용 래퍼 — 세션이 무효화(다른 기기 로그인 등)되어 401이
// 오면 등록된 콜백(GameScene의 강제 로그아웃)을 한 번 호출한다.
// 로그인/세션 복원처럼 401이 정상 흐름인 곳은 이 래퍼 대신 fetch를 그대로 쓴다.
let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: (() => void) | null): void {
  onUnauthorized = cb;
}

export async function apiFetch(input: string, init?: RequestInit): Promise<Response> {
  const res = await fetch(input, { credentials: "include", ...init });
  if (res.status === 401) onUnauthorized?.();
  return res;
}
